import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseComponent } from '@app/shared/base/components/base-component';
import { Tenant } from '@app/shared/models/classes/Tenant';
import { RoleHelper } from '@app/shared/models/local/role.helper';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'hypecast-master-admin-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, RouterLink],
})
export class UserInfoComponent extends BaseComponent {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);
  readonly user = computed(() => this.authenticationService.credentialsSignal()?.user ?? null);

  RoleHelper = RoleHelper;

  tenant!: Tenant;

  /**
   * Logs the current user out (destroys the locally storaged items) and redirects
   * the user to the login page.
   */
  logout() {
    this.router.navigate(['/login']).then((_q: boolean) => {
      // eslint-disable-next-line rxjs-x/no-ignored-subscription
      this.authenticationService.logout().subscribe({
        next: (_data: unknown) => {
          /* intentionally empty */
        },
        error: () => {
          /* handled by interceptor */
        },
      });
    });
  }

  trackByRole: (_index: number, role: string) => string = (_index: number, role: string) => role;
}
